module.exports = __webpack_public_path__ + "static/media/figtree-latin-ext-700.7ac4f777.woff2";